






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DangerButton extends Vue {
  @Prop({ default: "" }) readonly icon!: string;
  @Prop({ default: "" }) readonly id!: string;
  @Prop() readonly text!: string;
}
